document.addEventListener('DOMContentLoaded', function() {

    const el = document.querySelector('.js-boxesSwiper');

    const init = function() {

        const slide = el.querySelectorAll('.swiper-slide'),
              row1 = el.querySelectorAll('.row-1'),
              row2 = el.querySelectorAll('.row-2');
        
        const mouseEnter = function(e) {
            const current = e.currentTarget;

            if (e.currentTarget.classList.contains('row-1')) {
                for (let i = 0; i < row1.length; i++) {                    
                    row1[i] != current ? row1[i].classList.add('hover') : false;
                }
                current.classList.add('current');
            }

            if (e.currentTarget.classList.contains('row-2')) {
                for (let i = 0; i < row2.length; i++) {                    
                    row2[i] != current ? row2[i].classList.add('hover') : false;
                }
                current.classList.add('current');
            }
        }
        
        const mouseOut = function(e) {
            const current = e.currentTarget;

            for (let i = 0; i < slide.length; i++) {                    
                slide[i].classList.remove('current', 'hover');
            }
        }
        
        for (let i = 0; i < slide.length; i++) {
            slide[i].addEventListener('mouseenter', mouseEnter);
        }
        
        for (let i = 0; i < slide.length; i++) {
            slide[i].addEventListener('mouseout', mouseOut);
        }
    };
    
    el ? init() : false;

}, false);
